import { CardActionGroup } from '@/common/components/CardActionGroup/CardActionGroup';
import { CardExpirationBanner } from '@/common/components/CardExpirationBanner/CardExpirationBanner';
import { CardStatusBanner } from '@/common/components/CardStatusBanner/CardStatusBanner';
import { LoadingPlaceholder } from '@/common/components/LoadingPlaceholder/LoadingPlaceholder';
import { useEmployeeDetails } from '@/common/contexts/user/UserDetailsContext';
import { useGetCardsData } from '@/common/integrations/menhir/employee/card/card.hooks';

export const ProfileCardSection = () => {
  const { company } = useEmployeeDetails();

  const {
    cards = [],
    isInitialLoading: loadingCards,
    expiredCard,
    expiringCard,
  } = useGetCardsData();

  if (loadingCards) {
    return <LoadingPlaceholder />;
  }

  const showCardExpirationBanner =
    (expiredCard || expiringCard) && cards.length === 1;

  return (
    <>
      {showCardExpirationBanner && (
        <CardExpirationBanner
          isExpired={Boolean(expiredCard)}
          isDigitalRequestFormatRenewal={
            company.settings.cardRequestFormat === 'digital'
          }
        />
      )}

      {cards.length > 0 && (
        <CardActionGroup>
          {cards.map((card) => (
            <CardStatusBanner key={card.id} card={card} />
          ))}
        </CardActionGroup>
      )}
    </>
  );
};
